import * as _4 from 'lodash4';
import { PronounsQuery } from 'capability-ng-priority-feed';
import { PronounsListQuery } from '../queries/pronouns_list_query';
import { NO_PRONOUNS_STRING } from '../main';

export class EditPronounsService {
  private _isOpen: boolean;
  private _isStudentPronounCustom: boolean;
  private _selectedPronoun: string;

  constructor(private ngPronounsQuery: PronounsQuery, private ngPronounsListQuery: PronounsListQuery) {
    this._isOpen = false;
    this._selectedPronoun = _4.get(this.ngPronounsQuery.result, 'selected_pronouns');
  }

  get isOpen(): boolean {
    return this._isOpen;
  }

  get isStudentPronounCustom(): boolean {
    return this._isStudentPronounCustom;
  }

  checkIsStudentPronounCustom() {
    const studentPronoun = _4.get(this.ngPronounsQuery.result, 'selected_pronouns');
    this._selectedPronoun = studentPronoun === NO_PRONOUNS_STRING ? '' : (studentPronoun as string);
    this._isStudentPronounCustom = this.ngPronounsListQuery.isPronounsCustom(this._selectedPronoun);
  }

  setPronounsInitialValue() {
    const selectElement = document.querySelector('#pronounsSelect') as HTMLElement;
    if (this._isStudentPronounCustom) {
      selectElement.setAttribute('value', 'custom');
    } else {
      selectElement.setAttribute('value', this._selectedPronoun);
    }
  }

  toggleOpen(state: boolean) {
    if (state) {
      this.checkIsStudentPronounCustom();
      this.setPronounsInitialValue();
    }
    this._isOpen = state;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/services/edit_pronouns_service.ts